import { render, staticRenderFns } from "./SendResetPasswordInstruction.vue?vue&type=template&id=738d7482&scoped=true&"
import script from "./SendResetPasswordInstruction.vue?vue&type=script&lang=js&"
export * from "./SendResetPasswordInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d7482",
  null
  
)

export default component.exports